<template>
  <div>
    <v-container grid-list-xl fluid class="white pl-6 pr-5 pt-6">
      <v-layout row wrap class="pr-5 pl-2">
        <v-flex class="py-0">
          <h2 class="primary--text breadcrumbs fs-16 lh-29 font-weight-700">
            Summary Report
          </h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-breadcrumbs
          class="px-0 fs-12 lh-15 py-0 breadcrumbs-items custom-breadcrumbs text-uppercase"
          :items="breadcrumbs"
        ></v-breadcrumbs>
      </v-layout>
    </v-container>

    <v-layout class="tab-monthly">
      <v-tabs v-model="tab" background-color="white" color="menuActive">
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="(item, index) in entities"
          :key="index"
          :to="{ name: 'monthly-topline-report', params: { id: item.initial } }"
          class="text-left px-0 d-block pt-3 mr-10"
          style="min-width: 100px !important; height:100%"
        >
          <span class="text-capitalize fs-12 font-weight-600 text-left">
            {{ item.name }}
          </span>
        </v-tab>
      </v-tabs>
      <v-flex xs3 class="pr-8 white pt-2">
        <date-picker
          v-model="year"
          type="month"
          placeholder="Start Date"
          format="MMMM YYYY"
          class="date-font fs-12"
          dense
        />
      </v-flex>
    </v-layout>
    <v-row>
      <v-col cols="12">
        <table-monthly :itemsTable="itemSH" :tab="id" @getData="getSummary(id)">
        </table-monthly>
      </v-col>
    </v-row>
    <progress-dialog
      :show="progressDialogLoading"
      text="Please wait"
    ></progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import Swal from 'sweetalert2';
import { mapGetters, mapState } from 'vuex';
import tableMonthly from '../../../components/monthlyReport/tableMonthly';

export default {
  name: 'SpendingReportIndex',
  components: {
    'progress-dialog': ProgressDialog,
    'table-monthly': tableMonthly
  },
  props: ['id'],
  mixins: [ACLMixin],
  data() {
    return {
      year: new Date(),
      search: [],
      searchmonth: [],
      sortColumn: '',
      sortType: '',
      initializing: false,
      timeout: null,
      progressDialogLoading: true,
      breadcrumbs: [
        {
          text: 'MONTHLY REPORT',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Summary Report',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        }
      ],
      items: [],
      profile: {},
      user: {},
      profile_id: localStorage.getItem('profile_id'),
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
        'Q1',
        'Q2',
        'Q3',
        'Q4',
        'Full Year IO'
      ],
      totalItems: 0,
      options: {
        itemsPerPage: 10
      },
      headers: [],
      baseUrl: process.env.VUE_APP_BASE_URL,
      itemSH: [],
      filters: [],
      showFilterDialog: false,
      showFilterDivision: false,
      showFilterHouse: false,
      showFilterDept: false,
      showFilterBo: false,
      divisionList: [],
      houseList: [],
      deptList: [],
      boList: [],
      divisionObj: [],
      houseObj: [],
      deptObj: [],
      boObj: [],
      isDisable: false,
      year1: new Date(),
      year2: new Date(),
      isDisabledHouse: false,
      isDisabledDept: false,
      isDisabledBo: false,
      filter: '',
      entities: [
        {
          id: 0,
          name: 'SN Indonesia',
          initial: 'all'
        },
        {
          id: 1,
          name: 'SH',
          initial: 'sh'
        },
        {
          id: 2,
          name: 'NIS',
          initial: 'nis'
        },
        {
          id: 3,
          name: 'NMN',
          initial: 'nmn'
        }
      ],
      tab: 0
    };
  },
  watch: {
    '$route.params.id'(val) {
      this.getSummary(val);
    },
    year() {
      this.getSummary(this.id);
    }
  },
  computed: {
    ...mapState('auth', ['userRole']),
    ...mapGetters('auth', ['userMapping'])
  },
  mounted() {
    this.filters = JSON.parse(localStorage.getItem('filters'));
    this.getSummary(this.id);
  },
  methods: {
    async getSummary(name) {
      let entity = name || this.$route.params.id;
      this.progressDialogLoading = true;
      await this.$store
        .dispatch('monthlyReport/getSummary', {
          entity: entity.toUpperCase(),
          date: this.formattedDate(this.year)
        })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.itemSH = data.data;
          } else {
            this.progressDialogLoading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
        });
    }
  }
};
</script>
<style scoped>
.drawer-menu--scroll {
  max-height: 340px;
  overflow: auto;
}
.drawer-menu--scrollEdit {
  max-height: 450px;
  overflow: auto;
}
v-dialog {
  overflow-y: hidden !important;
}
.hr-line {
  margin-bottom: 10px;
  margin-top: 20px;
  border: 1px solid rgb(151, 151, 151);
}
</style>
